<template>
  <TransitionRoot appear :show="showModal" as="template">
    <Dialog as="div" @close="closeModal">
      <div class="fixed inset-0 z-30 overflow-y-auto">
        <div class="min-h-screen text-center flex">
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0"
            enter-to="opacity-10"
            leave="duration-200 ease-in"
            leave-from="opacity-10"
            leave-to="opacity-0"
          >
            <DialogOverlay class="fixed inset-0 bg-black opacity-30" />
          </TransitionChild>

          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-50"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-50"
          >
            <div
              class="inline-block w-full mx-3 md:w-1/2 md:mx-auto max-w-screen-md m-auto overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded overflow-y-scroll"
            >
              <div class="flex flex-row">
                <div class="flex-1"></div>
                <div class="flex-4 pr-2 pt-2 cursor-pointer" @click="closeModal(false)">
                  <XIcon class="text-brand-dark-gray w-7 h-7" ref="close" />
                </div>
              </div>

              <div class="pb-2 px-5 md:px-8">
                <h3 class="text-brand-black py-1">Decline applicant</h3>
              </div>

              <template v-if="selectedBundle">
                <template v-if="state === 'due_to_others'">
                  <div class="pb-5 px-5 md:px-8">
                    <div class="py-2 flex flex-row items-center">
                      <input
                        id="cc"
                        type="checkbox"
                        class="rounded border-gray-300 text-brand-green focus:ring-brand-green w-4 h-4"
                        v-model="cc"
                      />
                      <label for="cc" class="ml-2 block text-sm text-brand-black"
                        >Send me a copy</label
                      >
                    </div>

                    <div class="flex flex-col mb-3">
                      <label for="subject" class="block text-brand-black"> Subject </label>
                      <SingleLineInput
                        id="subject"
                        type="text"
                        :placeholder="`Application for ${selectedBundle.applications[0].unit_address} Rejected`"
                        :value="subject"
                        @input="subject = $event.target.value"
                      ></SingleLineInput>
                    </div>

                    <!-- <template v-if="selectedBundle.applications.length"> -->
                    <div
                      class="flex flex-col pb-3"
                      v-for="app in selectedBundle.applications"
                      :key="app.id"
                    >
                      <label for="customMessage" class="block text-brand-black">
                        Custom message for {{ app.applicant.name }}
                      </label>
                      <MultiLineInput
                        id="customMessage"
                        :placeholder="`Dear ${app.applicant.name},\n\nUnfortunately, we regret to inform you that your application to live at ${app.unit_address} was not accepted. For questions about why your application was not accepted, do not reply to this email. Please contact the following:\n\n${getCurrentUser.landlord.name}\n${getCurrentUser.landlord.display_email}\n`"
                        :value="customMessage[app.id]"
                        @input="customMessage[app.id] = $event.target.value"
                        :rows="6"
                      ></MultiLineInput>
                    </div>
                    <!-- </template> -->
                    <!-- <template v-else>
                    <div class="flex flex-col pb-3">
                      <label for="customMessage" class="block text-brand-black">
                        Custom message
                      </label>
                      <MultiLineInput
                        id="customMessage"
                        :placeholder="`Dear ${selectedApplication.applicant.name},\n\nUnfortunately, we regret to inform you that your application to live at ${selectedApplication.unit_address} was not accepted. For questions about why your application was not accepted, do not reply to this email. Please contact the following:\n\n${getCurrentUser.landlord.name}\n${getCurrentUser.landlord.display_email}\n`"
                        :value="customMessage[selectedApplication.id]"
                        @input="customMessage[selectedApplication.id] = $event.target.value"
                        :rows="6"
                      ></MultiLineInput>
                    </div>
                  </template> -->

                    <div class="pt-10 flex flex-col md:flex-row justify-between w-full">
                      <div class="w-full py-1 md:w-1/2">
                        <SecondaryButton
                          :classes="'border-brand-mid-gray'"
                          @click="rejectApplicant(false, false)"
                          >No thanks, don't send email</SecondaryButton
                        >
                      </div>
                      <div class="md:w-1/3 py-1">
                        <PrimaryButton
                          @click="rejectApplicant(true, false)"
                          :classes="'bg-brand-red border-brand-red hover:bg-brand-red'"
                          >Send email</PrimaryButton
                        >
                      </div>
                    </div>
                  </div>
                </template>

                <template v-else-if="state === 'due_to_reports'">
                  <div class="pb-5 px-5 md:px-8">
                    <h2>Reason for rejection</h2>

                    <p class="py-5">
                      If an applicant is rejected due to information contained in consumer reports,
                      the Fair Credit Reporting Act requires you to notify the applicant of the
                      reasons in an "Adverse Action" letter.
                    </p>

                    <p class="py-1">
                      Select the reasons for rejection below and we'll notify the applicant:
                    </p>

                    <div class="py-2 px-5 md:px-8 flex flex-row items-center">
                      <input
                        id="cc"
                        type="checkbox"
                        class="rounded border-gray-300 text-brand-green focus:ring-brand-green w-4 h-4"
                        v-model="cc"
                      />
                      <label for="cc" class="ml-2 block text-sm text-brand-black"
                        >Send me a copy</label
                      >
                    </div>
                    <!-- <template v-if="selectedApplication.bundle.applications.length"> -->
                    <div
                      class="flex flex-col pb-3"
                      v-for="app in selectedBundle.applications"
                      :key="app.id"
                    >
                      <p class="py-1">
                        Rejection reason(s) for {{ app.applicant.name }}
                        <span class="text-brand-red">*</span>
                      </p>

                      <div
                        v-for="(reason, index) in selectedReasons[app.id]"
                        :key="index"
                        class="py-1"
                      >
                        <DropDown
                          :options="reasonOptions"
                          @select="selectSection(app.id, index, $event)"
                          :placeholder="
                            selectedReasons[app.id][index]
                              ? selectedReasons[app.id][index].value
                              : '' || 'Select reason'
                          "
                        ></DropDown>

                        <template v-if="reason.value === 'Other'">
                          <SingleLineInput
                            type="text"
                            placeholder="Please explain your reason"
                            :value="reason.other"
                            @input="reason.other = $event.target.value"
                          ></SingleLineInput>
                        </template>
                      </div>
                      <p
                        class="italic text-brand-dark-gray underline cursor-pointer"
                        @click="addReason(app.id)"
                      >
                        Add another reason
                      </p>
                    </div>
                    <!-- </template> -->

                    <!-- <template v-else>
                    <p class="py-1">Reason for rejection</p>
                    <div
                      v-for="(reason, index) in selectedReasons[selectedApplication.id]"
                      :key="index"
                      class="py-1"
                    >
                      <DropDown
                        :options="reasonOptions"
                        @select="selectSection(selectedApplication.id, index, $event)"
                        :placeholder="
                          selectedReasons[selectedApplication.id][index]
                            ? selectedReasons[selectedApplication.id][index].value
                            : '' || 'Select reason'
                        "
                      ></DropDown>

                      <template v-if="reason.value === 'Other'">
                        <SingleLineInput
                          type="text"
                          placeholder="Please explain your reason"
                          :value="reason.other"
                          @input="reason.other = $event.target.value"
                        ></SingleLineInput>
                      </template>
                    </div>
                    <p
                      class="italic text-brand-dark-gray underline cursor-pointer"
                      @click="addReason(selectedApplication.id)"
                    >
                      Add another reason
                    </p>
                  </template> -->

                    <div class="pt-10 flex flex-col md:flex-row justify-between w-full">
                      <div class="w-full py-1 md:w-1/3">
                        <SecondaryButton
                          :classes="'border-brand-mid-gray'"
                          @click="closeModal(false)"
                          >Cancel</SecondaryButton
                        >
                      </div>
                      <div class="w-full py-1 md:w-1/3">
                        <PrimaryButton
                          @click="rejectApplicant(true, true)"
                          :classes="'bg-brand-red border-brand-red hover:bg-brand-red'"
                          >Send email</PrimaryButton
                        >
                      </div>
                    </div>
                  </div>
                </template>

                <template v-else>
                  <div class="pb-2 px-5 md:px-8">
                    <h2 class="text-xl text-brand-black py-1">
                      Consumer reports notification requirement
                    </h2>
                    <p class="py-5">
                      You are about to reject
                      {{ selectedBundle.applications.map((app) => app.applicant_name).join(", ") }}
                      for
                      {{ selectedBundle.applications[0].unit_address || "Address Not Provided" }}.
                    </p>

                    <p class="py-1">
                      If you are rejecting the applicant based on information contained in consumer
                      reports,
                      <span class="font-semibold">
                        then you are required to let the applicant know why.</span
                      >
                    </p>

                    <p class="py-1">
                      If you are rejecting them for any other reason, then notifying the applicant
                      is optional.
                    </p>
                  </div>

                  <div class="px-5 md:px-8 my-3 border border-brand-light-gray"></div>

                  <div class="pb-5 px-5 md:px-8">
                    <h5 class="py-1">
                      Is this rejection due to information found in consumer reports?
                    </h5>
                  </div>

                  <div class="px-5 pb-8 md:px-8 flex flex-col md:flex-row justify-between w-full">
                    <div class="py-1">
                      <SecondaryButton
                        :classes="'border-brand-red'"
                        @click="state = 'due_to_others'"
                        >No, there were other reasons</SecondaryButton
                      >
                    </div>
                    <div class="py-1">
                      <PrimaryButton
                        @click="state = 'due_to_reports'"
                        :classes="'bg-brand-red border-brand-red hover:bg-brand-red'"
                        >Yes, help me generate an adverse action email</PrimaryButton
                      >
                    </div>
                  </div>
                </template>
              </template>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
<script>
import { mapGetters } from "vuex"
import _ from "lodash"

import { TransitionRoot, TransitionChild, Dialog, DialogOverlay } from "@headlessui/vue"

import { APPLICATION_BUNDLE_REJECT, APPLICATION_BUNDLE_GET } from "@/store/types"

import { XIcon } from "@heroicons/vue/outline"

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    bundle: {
      type: Object
    }
  },
  emit: ["close"],
  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    XIcon
  },
  computed: {
    ...mapGetters([
      "isApplicationBundleLoading",
      "getCurrentApplication",
      "getCurrentApplicationBundle",
      "getCurrentUser"
    ]),
    selectedBundle() {
      if (this.bundle) {
        return this.bundle
      }
      return this.getCurrentApplicationBundle
    }
  },
  data() {
    return {
      cc: false,
      subject: "",
      customMessage: {},
      state: "default",
      selectedReasons: {},
      reasonOptions: [
        { label: "Credit score", value: "Credit score" },
        {
          label: "Past rental history or unable to verify rental history",
          value: "Past rental history or unable to verify rental history"
        },
        {
          label: "Income/Past employment history or unable to verify employment history",
          value: "Income/Past employment history or unable to verify employment history"
        },
        { label: "Bankruptcy", value: "Bankruptcy" },
        {
          label: "Delinquent past or present credit obligations",
          value: "Delinquent past or present credit obligations"
        },
        { label: "Criminal Record", value: "Criminal Record" },
        {
          label:
            "Garnishment, attachment, foreclosure, repossession, collection action, or judgment",
          value:
            "Garnishment, attachment, foreclosure, repossession, collection action, or judgment"
        },
        { label: "Eviction", value: "Eviction" },
        { label: "Other", value: "Other" }
      ]
    }
  },
  async mounted() {
    if (!this.bundle) {
      await this.$store.dispatch(APPLICATION_BUNDLE_GET, {
        slug: this.getCurrentApplication.bundle.slug
      })
    }
    this.selectedBundle.applications.forEach((app) => {
      this.selectedReasons[app.id] = [{}]
    })
  },
  methods: {
    selectSection(appId, index, val) {
      this.selectedReasons[appId][index] = _.cloneDeep(val)
    },
    addReason(appId) {
      this.selectedReasons[appId].push({})
    },
    closeModal(reload = false) {
      this.$emit("close", reload)
      this.resetData()
    },
    resetData() {
      this.cc = false
      this.subject = ""
      this.customMessage = ""
      this.state = "default"
      this.selectedReasons = [{}]
    },
    async rejectApplicant(sendEmail, adverseAction) {
      const { subject, customMessage, cc } = this
      const slug = this.selectedBundle.slug
      const reasons = {}

      Object.keys(this.selectedReasons).forEach((appId) => {
        reasons[appId] = _.uniq(
          this.selectedReasons[appId].map((reason) => {
            if (reason.value === "Other") {
              return `${reason.value}: ${reason.other}`
            }
            return reason.value
          })
        ).filter(Boolean)
      })

      if (adverseAction && !Object.keys(reasons).every((appId) => !!reasons[appId].length)) {
        return
      }

      await this.$store.dispatch(APPLICATION_BUNDLE_REJECT, {
        slug,
        reasons,
        adverseAction,
        sendEmail,
        cc,
        subject,
        customMessage
      })
      this.closeModal(true)
    }
  }
}
</script>
<style scoped></style>
